const formatNumber = (value: number | string): string => {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }
  return (Math.round(value * 100) / 100).toFixed(2);
};

export default formatNumber;
